import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { faLeftLong } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MeasurementsTable from "./MeasurementsTable";
import React, {useContext} from "react";
import InitContext from "../pages/InitContext";

const Measurements = () => {
  const { t: t } = useTranslation();
  const context = useContext(InitContext);

  return (
    <div className="w3-display-container content-container">
      <div style={{ width: '100%', textAlign: 'right', paddingRight: "20px" }}>
        <label>{t("username")}: {context?.patient?.login}, {t("role")}: {t("patient").toLowerCase()}</label>
      </div>
      <div className="w3-display-middle form-display">
        <div className="w3-panel w3-card-4 record-panel">
          <MeasurementsTable>
            <h2>{t("measurements")}</h2>
          </MeasurementsTable>
          <footer className="w3-container w3-center w3-padding-small">
            <div className="w3-left w3-padding-small">
              <label className="w3-btn w3-round-xlarge w3-theme-d5">
                <NavLink to={`/diary/`} className="home-label">
                  <FontAwesomeIcon icon={faLeftLong} /> {t("to_your_diary")}
                </NavLink>
              </label>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default Measurements;
